import MuiIcon from 'components/MuiIcon';
import { useDragHandle } from './DraggableRow';

const RowDragHandleCell = () => {
  const { attributes, listeners } = useDragHandle();
  
  return (
    <button 
      {...attributes} 
      {...listeners}
      style={{ 
        border: 'none', 
        background: 'transparent', 
        cursor: 'grab',
        padding: '4px'
      }}
    >
      <MuiIcon name="drag_handle" />
    </button>
  )
}

export default RowDragHandleCell;
